import { AcUnit, BeachAccess, DescriptionOutlined, Email, Facebook, Instagram, KingBed, LinkedIn, Lock, Nature, Pets, Phone, PoolOutlined, SportsEsports, Star, SupportAgent, Telegram, Twitter, WhatsApp, X, YouTube } from "@mui/icons-material";

const { REACT_APP_API_URL } = process.env;


const DefaultConstants = {
    publicUrl: `/`,
    apiUrl: `${REACT_APP_API_URL ?? ''}`,
    
    websiteName: 'Thermas Soul Turismo',
    commercialName: 'Thermas Soul Turismo',
    document: '64.602.524/0001-35',

    developer: {
        name: 'Svn Sistemas',
        link: 'https://api.whatsapp.com/send?phone=5517997252265'
    },

    gridRowSpacing: 2,
    gridColumnSpacing: 2,
};

const WebsiteConstants = {
    home: {
        banners: [
            {
                title: 'banner1Title',
                description: 'banner1Description',
                wallpaper: 'assets/images/banners/1.jpg',
                align: 'center'
            }, {
                title: 'banner2Title',
                description: 'banner2Description',
                wallpaper: 'assets/images/banners/2.jpg',
                align: 'center'
            }, {
                title: 'banner3Title',
                description: 'banner3Description',
                wallpaper: 'assets/images/banners/3.jpg',
                align: 'center'
            }, {
                title: 'banner4Title',
                description: 'banner4Description',
                wallpaper: 'assets/images/banners/4.jpg',
                align: 'center'
            }, {
                title: 'banner5Title',
                description: 'banner5Description',
                wallpaper: 'assets/images/banners/5.jpg',
                align: 'center'
            }
        ],
        cards: [
            {
                Icon: BeachAccess,
                className: '',
                title: 'homeCard1Title',
                description: 'homeCard1Description',
                button: undefined
            }, {
                Icon: Lock,
                className: '',
                title: 'homeCard2Title',
                description: 'homeCard2Description',
                button: undefined
            }, {
                Icon: SupportAgent,
                className: '',
                title: 'homeCard3Title',
                description: 'homeCard3Description',
                button: undefined
            }, {
                Icon: DescriptionOutlined,
                className: 'backgroundcolor-primary',
                title: 'homeCard4Title',
                description: 'homeCard4Description',
                button: {
                    label: 'speakToSpecialist',
                    link: 'https://api.whatsapp.com/send?phone=5517996807737&text=Olá, gostaria de fazer um orçamento com vocês!'
                }
            }
        ]
    },
    address: {
        street: 'Av. do Tucano',
        number: '102',
        neighborhood: 'Jardim Luis Zucca',
        city: 'Olímpia/SP',
        zipCode: '15407-450',
        googleMaps: 'https://maps.app.goo.gl/UEKPTXb39R6JAMSD6'
    },
    contacts: [
        {
            link: 'mailto:thermassoulturismo@gmail.com',
            icon: Email,
            label: 'thermassoulturismo@gmail.com',
            className: ''
        }, {
            link: 'tel:5517996807737',
            icon: Phone,
            label: '(17) 99680-7737',
            className: ''
        }, {
            link: 'https://api.whatsapp.com/send?phone=5517996807737',
            icon: WhatsApp,
            label: '(17) 99680-7737',
            className: ''
        }, {
            link: 'https://api.whatsapp.com/send?phone=5517997393238',
            icon: WhatsApp,
            label: '(17) 99739-3238',
            className: ''
        }
    ],
    socialMedias: [
        {
            name: "whatsApp",
            icon: WhatsApp,
            link: 'https://api.whatsapp.com/send?phone=5517996807737'
        }, {
            name: "telegram",
            icon: Telegram,
            link: undefined
        }, {
            name: "instagram",
            icon: Instagram,
            link: 'https://www.instagram.com/thermassoulturismo/'
        }, {
            name: "facebook",
            icon: Facebook,
            link: undefined
        }, {
            name: "twitter",
            icon: Twitter,
            link: undefined
        }, {
            name: "x",
            icon: X,
            link: undefined
        }, {
            name: "linkedIn",
            icon: LinkedIn,
            link: undefined
        }, {
            name: "youTube",
            icon: YouTube,
            link: undefined
        }
    ],
    requestQuote: {
        wallpaper_default: 'assets/images/request-quote/default.jpg',
        link_default: 'https://api.whatsapp.com/send?phone=5517996807737&text=Olá, gostaria de fazer um orçamento com vocês!',
        wallpaper_tickets: 'assets/images/request-quote/tickets.jpg',
        link_tickets: 'https://api.whatsapp.com/send?phone=5517996807737&text=Olá, gostaria de comprar ingressos!',
        wallpaper_reservation: 'assets/images/request-quote/reservation.jpg',
        link_reservation: 'https://api.whatsapp.com/send?phone=5517996807737&text=Olá, gostaria de cotar hospedagens!'
    },
    otherDestinations: [
        {
            key: 'olimpia-sp',
            city: 'Olímpia',
            state: 'São Paulo',
            description: 'destinationOlimpiaSpDescription',
            wallpaper: 'assets/images/olimpia-sp/wallpaper.jpg',
            hotels: [
                {
                    key: 'solaraguasresort-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Enjoy Solar das Águas Park Resort',
                    type: 'resort',
                    Icon: BeachAccess,
                    description: 'attractionSolarAguasResortOlimpiaSpDescription',
                    wallpaper: 'assets/images/solaraguasresort-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.174117522841!2d-48.92213822492839!3d-20.70315298086592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fad68000003%3A0x12cfac2685e6b6b4!2sEnjoy%20Solar%20das%20%C3%81guas%20Park%20Resort!5e0!3m2!1spt-BR!2sbr!4v1770129632323!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/solaraguasresort-olimpia-sp/1.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/2.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/3.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/4.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/5.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/6.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/7.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/8.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/9.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/10.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/11.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/12.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/13.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/14.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/15.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/16.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/17.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/18.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/19.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/20.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/21.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/22.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/23.jpg',
                        'assets/images/solaraguasresort-olimpia-sp/24.jpg'
                    ]
                }, {
                    key: 'olimpiaparkresort-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Enjoy Olímpia Park Resort',
                    type: 'resort',
                    Icon: BeachAccess,
                    description: 'attractionOlimpiaParkResortOlimpiaSpDescription',
                    wallpaper: 'assets/images/olimpiaparkresort-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29857.393185129957!2d-48.94016293918054!3d-20.703151737123864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6e54b8d3b675%3A0x612c9e3720c3fe73!2sEnjoy%20Ol%C3%ADmpia%20Park%20Resort!5e0!3m2!1spt-BR!2sbr!4v1770130379114!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/olimpiaparkresort-olimpia-sp/1.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/2.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/3.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/4.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/5.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/6.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/7.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/8.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/9.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/10.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/11.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/12.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/13.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/14.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/15.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/16.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/17.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/18.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/19.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/20.jpg',
                        'assets/images/olimpiaparkresort-olimpia-sp/21.jpg',
                    ]
                }, {
                    key: 'hotbeachresort-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hot Beach Resort',
                    type: 'resort',
                    Icon: BeachAccess,
                    description: 'attractionHotBeachResortOlimpiaSpDescription',
                    wallpaper: 'assets/images/hotbeachresort-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.8478530097245!2d-48.91519022050068!3d-20.716402031494166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fb06d12957d%3A0x4b0dd454e387af6b!2sHot%20Beach%20Resort!5e0!3m2!1spt-BR!2sbr!4v1770131880783!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotbeachresort-olimpia-sp/1.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/2.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/3.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/4.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/5.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/6.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/7.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/8.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/9.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/10.jpg',
                        'assets/images/hotbeachresort-olimpia-sp/11.jpg'
                    ]
                }, {
                    key: 'hotbeachsuites-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hot Beach Suites',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotBeachSuitesOlimpiaSpDescription',
                    wallpaper: 'assets/images/hotbeachsuites-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.8614441278964!2d-48.91330412492801!3d-20.715850280856273!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6f53afd8c717%3A0xcf2874099f78ad4c!2sHot%20Beach%20Suites!5e0!3m2!1spt-BR!2sbr!4v1770132065074!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotbeachsuites-olimpia-sp/1.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/2.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/3.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/4.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/5.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/6.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/7.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/8.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/9.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/10.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/11.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/12.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/13.jpg',
                        'assets/images/hotbeachsuites-olimpia-sp/14.jpg'
                    ]
                }, {
                    key: 'hotbeachcelebration-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hot Beach Celebration',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotBeachCelebrationOlimpiaSpDescription',
                    wallpaper: 'assets/images/hotbeachcelebration-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.6812868097636!2d-48.915629424927836!3d-20.723162880850783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6facd24f2987%3A0x8d0e86ffedd5d7a1!2sHot%20Beach%20Celebration!5e0!3m2!1spt-BR!2sbr!4v1770132531646!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotbeachcelebration-olimpia-sp/1.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/2.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/3.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/4.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/5.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/6.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/7.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/8.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/9.jpg',
                        'assets/images/hotbeachcelebration-olimpia-sp/10.jpg'
                    ]
                }, {
                    key: 'hotbeachraizes-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hot Beach Raízes',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotBeachRaizesOlimpiaSpDescription',
                    wallpaper: 'assets/images/hotbeachraizes-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.7142994229544!2d-48.91882242492802!3d-20.721823080851802!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6e5b44bfa651%3A0x3814226dd3f602f3!2sHot%20Bech%20Ra%C3%ADzes%20(antigo%20Thermas%20Park)!5e0!3m2!1spt-BR!2sbr!4v1770138380896!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotbeachraizes-olimpia-sp/1.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/2.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/3.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/4.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/5.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/6.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/7.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/8.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/9.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/10.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/11.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/12.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/13.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/14.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/15.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/16.jpg',
                        'assets/images/hotbeachraizes-olimpia-sp/17.jpg'
                    ]
                }, {
                    key: 'thermasolimpiaresort-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Thermas de Olímpia Resort',
                    type: 'resort',
                    Icon: BeachAccess,
                    description: 'attractionThermasOlimpiaResortOlimpiaSpDescription',
                    wallpaper: 'assets/images/thermasolimpiaresort-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.7124539440906!2d-48.91881322492794!3d-20.72189798085172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fad6183b5eb%3A0x9eb505faccb668d4!2sThermas%20de%20Olimpia%20Resort!5e0!3m2!1spt-BR!2sbr!4v1770138865742!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/thermasolimpiaresort-olimpia-sp/1.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/2.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/3.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/4.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/5.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/6.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/7.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/8.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/9.jpg',
                        'assets/images/thermasolimpiaresort-olimpia-sp/10.jpg'
                    ]
                }, {
                    key: 'wyndhamolimpiaroyal-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Wyndham Olímpia Royal',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionWyndhamOlimpiaRoyalOlimpiaSpDescription',
                    wallpaper: 'assets/images/wyndhamolimpiaroyal-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.8239990957904!2d-48.920264524927994!3d-20.717370380855243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fa8fe446ec9%3A0x5ccb78373a2d5e26!2sWyndham%20Ol%C3%ADmpia%20Royal%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1770139201135!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/1.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/2.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/3.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/4.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/5.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/6.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/7.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/8.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/9.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/10.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/11.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/12.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/13.jpg',
                        'assets/images/wyndhamolimpiaroyal-olimpia-sp/14.jpg'
                    ]
                }, {
                    key: 'carpediem-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Carpe Diem Eco Resort',
                    type: 'resort',
                    Icon: BeachAccess,
                    description: 'attractionCarpeDiemOlimpiaSpDescription',
                    wallpaper: 'assets/images/carpediem-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3730.5012507679608!2d-48.923819724926446!3d-20.77099978081461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6c2c9645916b%3A0xb477109f70e7a520!2sCarpe%20Diem%20Eco%20Resort%20Ol%C3%ADmpia!5e0!3m2!1spt-BR!2sbr!4v1770139690144!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/carpediem-olimpia-sp/1.jpg',
                        'assets/images/carpediem-olimpia-sp/2.jpg',
                        'assets/images/carpediem-olimpia-sp/3.jpg',
                        'assets/images/carpediem-olimpia-sp/4.jpg',
                        'assets/images/carpediem-olimpia-sp/5.jpg',
                        'assets/images/carpediem-olimpia-sp/6.jpg',
                        'assets/images/carpediem-olimpia-sp/7.jpg',
                        'assets/images/carpediem-olimpia-sp/8.jpg',
                        'assets/images/carpediem-olimpia-sp/9.jpg',
                        'assets/images/carpediem-olimpia-sp/10.jpg',
                        'assets/images/carpediem-olimpia-sp/11.jpg',
                        'assets/images/carpediem-olimpia-sp/12.jpg',
                        'assets/images/carpediem-olimpia-sp/13.jpg',
                        'assets/images/carpediem-olimpia-sp/14.jpg',
                        'assets/images/carpediem-olimpia-sp/15.jpg'
                    ]
                }, {
                    key: 'mirantepraiahotel-olimpia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Mirante Praia Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionMirantePraiaHotelOlimpiaSpDescription',
                    wallpaper: 'assets/images/mirantepraiahotel-olimpia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3729.791139874241!2d-48.960101620484686!3d-20.799735931268657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6e670b3d1441%3A0x8cc6eed58c476e9f!2sMirante%20Praia%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1770140116870!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/mirantepraiahotel-olimpia-sp/1.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/2.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/3.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/4.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/5.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/6.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/7.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/8.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/9.jpg',
                        'assets/images/mirantepraiahotel-olimpia-sp/10.jpg'
                    ]
                }
            ],
            parks: [
                {
                    key: 'thermaslaranjais-olimpia-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Thermas dos Laranjais',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionThermasLaranjaisOlimpiaSpDescription',
                    wallpaper: 'assets/images/thermaslaranjais-olimpia-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourEveryDays',
                            value: '9h {at} 17h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29853.711267512685!2d-48.938255310058594!3d-20.721838949216494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fab74385651%3A0xf64f5b329d1e135d!2sThermas%20dos%20Laranjais!5e0!3m2!1spt-BR!2sbr!4v1769539332911!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/thermaslaranjais-olimpia-sp/1.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/2.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/3.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/4.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/5.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/6.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/7.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/8.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/9.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/10.jpg',
                        'assets/images/thermaslaranjais-olimpia-sp/11.jpg'
                    ]
                }, {
                    key: 'hotbeach-olimpia-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Hot Beach',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionHotBeachOlimpiaSpDescription',
                    wallpaper: 'assets/images/hotbeach-olimpia-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourTuesdayToSunday',
                            value: '9h {at} 17h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.755583668178!2d-48.908813221271885!3d-20.720147464352223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fb3b1d2702b%3A0xfac91f10a3aa56dc!2sHot%20Beach%20Ol%C3%ADmpia!5e0!3m2!1spt-BR!2sbr!4v1770125862686!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotbeach-olimpia-sp/1.jpg',
                        'assets/images/hotbeach-olimpia-sp/2.jpg',
                        'assets/images/hotbeach-olimpia-sp/3.jpg',
                        'assets/images/hotbeach-olimpia-sp/4.jpg',
                        'assets/images/hotbeach-olimpia-sp/5.jpg',
                        'assets/images/hotbeach-olimpia-sp/6.jpg',
                        'assets/images/hotbeach-olimpia-sp/7.jpg',
                        'assets/images/hotbeach-olimpia-sp/8.jpg'
                    ]
                }, {
                    key: 'orionverso-olimpia-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Orionverso Mundo Virtual',
                    type: 'themePark',
                    Icon: SportsEsports,
                    description: 'attractionOrionversoOlimpiaSpDescription',
                    wallpaper: 'assets/images/orionverso-olimpia-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourEveryDays',
                            value: '10h {at} 23h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.54343377927!2d-48.91667842492768!3d-20.72875668084652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6f0039b610cf%3A0xb43b8a87c5c9dd0b!2sOrionverso%20Mundo%20Virtual!5e0!3m2!1spt-BR!2sbr!4v1770126125264!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/orionverso-olimpia-sp/1.jpg',
                        'assets/images/orionverso-olimpia-sp/2.jpg',
                        'assets/images/orionverso-olimpia-sp/3.jpg',
                        'assets/images/orionverso-olimpia-sp/4.jpg',
                        'assets/images/orionverso-olimpia-sp/5.jpg',
                        'assets/images/orionverso-olimpia-sp/6.jpg',
                        'assets/images/orionverso-olimpia-sp/7.jpg',
                        'assets/images/orionverso-olimpia-sp/8.jpg',
                        'assets/images/orionverso-olimpia-sp/9.jpg',
                        'assets/images/orionverso-olimpia-sp/10.jpg',
                        'assets/images/orionverso-olimpia-sp/11.jpg',
                        'assets/images/orionverso-olimpia-sp/12.jpg'
                    ]
                }, {
                    key: 'valedinossauros-olimpia-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Vale dos Dinossauros',
                    type: 'themePark',
                    Icon: Pets,
                    description: 'attractionValeDinossaurosOlimpiaSpDescription',
                    wallpaper: 'assets/images/valedinossauros-olimpia-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourEveryDays',
                            value: '9h {at} 19h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.824435119769!2d-48.90956672492789!3d-20.717352680855104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fde47c41067%3A0x816ee294ac1085a4!2sVale%20dos%20Dinossauros!5e0!3m2!1spt-BR!2sbr!4v1770126552613!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/valedinossauros-olimpia-sp/1.jpg',
                        'assets/images/valedinossauros-olimpia-sp/2.jpg',
                        'assets/images/valedinossauros-olimpia-sp/3.jpg',
                        'assets/images/valedinossauros-olimpia-sp/4.jpg',
                        'assets/images/valedinossauros-olimpia-sp/5.jpg',
                        'assets/images/valedinossauros-olimpia-sp/6.jpg',
                        'assets/images/valedinossauros-olimpia-sp/7.jpg',
                        'assets/images/valedinossauros-olimpia-sp/8.jpg',
                        'assets/images/valedinossauros-olimpia-sp/9.jpg',
                        'assets/images/valedinossauros-olimpia-sp/10.jpg',
                        'assets/images/valedinossauros-olimpia-sp/11.jpg'
                    ]
                }, {
                    key: 'museucera-olimpia-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Dreamland Museu de Cera',
                    type: 'themePark',
                    Icon: Star,
                    description: 'attractionMuseuCeraOlimpiaSpDescription',
                    wallpaper: 'assets/images/museucera-olimpia-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourSundayToWednesday',
                            value: '10h {at} 20h30'
                        }, {
                            label: 'openingHourThursdayToSaturday',
                            value: '10h {at} 22h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.394002318363!2d-48.91387202492752!3d-20.734818680841897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6f30a323c36f%3A0x7533b171205ef78f!2sDreamland%20Museu%20de%20Cera%20Ol%C3%ADmpia!5e0!3m2!1spt-BR!2sbr!4v1770126932442!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/museucera-olimpia-sp/1.jpg',
                        'assets/images/museucera-olimpia-sp/2.jpg',
                        'assets/images/museucera-olimpia-sp/3.jpg',
                        'assets/images/museucera-olimpia-sp/4.jpg',
                        'assets/images/museucera-olimpia-sp/5.jpg',
                        'assets/images/museucera-olimpia-sp/6.jpg',
                        'assets/images/museucera-olimpia-sp/7.jpg',
                        'assets/images/museucera-olimpia-sp/8.jpg',
                        'assets/images/museucera-olimpia-sp/9.jpg',
                        'assets/images/museucera-olimpia-sp/10.jpg',
                        'assets/images/museucera-olimpia-sp/11.jpg',
                        'assets/images/museucera-olimpia-sp/12.jpg',
                        'assets/images/museucera-olimpia-sp/13.jpg',
                        'assets/images/museucera-olimpia-sp/14.jpg',
                        'assets/images/museucera-olimpia-sp/15.jpg'
                    ]
                }, {
                    key: 'bargelo-olimpia-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Dreamland Bar de Gelo',
                    type: 'themePark',
                    Icon: AcUnit,
                    description: 'attractionBarGeloOlimpiaSpDescription',
                    wallpaper: 'assets/images/bargelo-olimpia-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourEveryDays',
                            value: '12h {at} 22h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.394002318363!2d-48.91387202492752!3d-20.734818680841897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6f6908445403%3A0x44efca00f932ce09!2sDreams%20Ice%20Bar!5e0!3m2!1spt-BR!2sbr!4v1770127931783!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/bargelo-olimpia-sp/1.jpg',
                        'assets/images/bargelo-olimpia-sp/2.jpg',
                        'assets/images/bargelo-olimpia-sp/3.jpg',
                        'assets/images/bargelo-olimpia-sp/4.jpg',
                        'assets/images/bargelo-olimpia-sp/5.jpg',
                        'assets/images/bargelo-olimpia-sp/6.jpg',
                        'assets/images/bargelo-olimpia-sp/7.jpg',
                        'assets/images/bargelo-olimpia-sp/8.jpg'
                    ]
                }, {
                    key: 'pitstopneve-olimpia-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Pit Stop da Neve',
                    type: 'themePark',
                    Icon: AcUnit,
                    description: 'attractionPitStopNeveOlimpiaSpDescription',
                    wallpaper: 'assets/images/pitstopneve-olimpia-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourSundayToThursday',
                            value: '14h {at} 22h'
                        }, {
                            label: 'openingHourFridayAndSaturday',
                            value: '14h {at} 23h30'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.453803318825!2d-48.91792632049743!3d-20.73239293145086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bc6fc0d501d34f%3A0xf4270fc634ee1760!2sPit%20Stop%20Da%20Neve%20Parque%20De%20Neve!5e0!3m2!1spt-BR!2sbr!4v1770128665268!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/pitstopneve-olimpia-sp/1.jpg',
                        'assets/images/pitstopneve-olimpia-sp/2.jpg',
                        'assets/images/pitstopneve-olimpia-sp/3.jpg',
                        'assets/images/pitstopneve-olimpia-sp/4.jpg'
                    ]
                }
            ],
            gallery: [
                'assets/images/olimpia-sp/1.jpg',
                'assets/images/olimpia-sp/2.jpg',
                'assets/images/olimpia-sp/3.jpg',
                'assets/images/olimpia-sp/4.jpg',
                'assets/images/olimpia-sp/5.jpg',
                'assets/images/olimpia-sp/6.jpg',
                'assets/images/olimpia-sp/7.jpg',
                'assets/images/olimpia-sp/8.jpg',
                'assets/images/olimpia-sp/9.jpg',
                'assets/images/olimpia-sp/10.jpg',
                'assets/images/olimpia-sp/11.jpg',
                'assets/images/olimpia-sp/12.jpg',
                'assets/images/olimpia-sp/13.jpg',
                'assets/images/olimpia-sp/14.jpg'
            ]
        }, {
            key: 'aguaslindoia-sp',
            city: 'Águas de Lindóia',
            state: 'São Paulo',
            description: 'destinationAguasLindoiaSpDescription',
            wallpaper: 'assets/images/aguaslindoia-sp/wallpaper.jpg',
            hotels: [
                {
                    key: 'hotelfredy-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hotel Fredy',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotelFredyAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/hotelfredy-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d93613.14883952084!2d-46.677133629172445!3d-22.512180941698343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c9110782800901%3A0x98cd1a9be0713afc!2sHotel%20Fredy!5e0!3m2!1spt-BR!2sbr!4v1770153533312!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotelfredy-aguaslindoia-sp/1.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/2.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/3.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/4.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/5.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/6.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/7.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/8.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/9.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/10.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/11.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/12.jpg',
                        'assets/images/hotelfredy-aguaslindoia-sp/13.jpg'
                    ]
                }, {
                    key: 'panoramahotelspa-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Panorama Hotel & Spa',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionPanoramaHotelSpaAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/panoramahotelspa-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.825717869338!2d-46.6319269248764!3d-22.473182679562605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c910ff3c4821b5%3A0xa6d53913f2ad516b!2sPanorama%20Hotel%20%26%20Spa!5e0!3m2!1spt-BR!2sbr!4v1770153844488!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/panoramahotelspa-aguaslindoia-sp/1.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/2.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/3.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/4.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/5.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/6.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/7.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/8.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/9.jpg',
                        'assets/images/panoramahotelspa-aguaslindoia-sp/10.jpg'
                    ]
                }, {
                    key: 'estalagemportucale-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Estalagem Portucale',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionEstalagemPortucaleAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/estalagemportucale-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.819989601447!2d-46.631650324876524!3d-22.473397879562487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c9113d3a7ead6b%3A0x7a5488bd82fb2a53!2sEstalagem%20Portucale!5e0!3m2!1spt-BR!2sbr!4v1770154028163!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/estalagemportucale-aguaslindoia-sp/1.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/2.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/3.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/4.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/5.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/6.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/7.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/8.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/9.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/10.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/11.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/12.jpg',
                        'assets/images/estalagemportucale-aguaslindoia-sp/13.jpg'
                    ]
                }, {
                    key: 'hotelcasablanca-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hotel Casablanca',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotelCasablancaAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/hotelcasablanca-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.8500730745036!2d-46.63385792487648!3d-22.472267679563323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c911ad3a12e1d9%3A0xd40baca7a12c6bac!2sHotel%20Casablanca%20%C3%81guas%20de%20Lind%C3%B3ia!5e0!3m2!1spt-BR!2sbr!4v1770154248093!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotelcasablanca-aguaslindoia-sp/1.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/2.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/3.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/4.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/5.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/6.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/7.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/8.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/9.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/10.jpg',
                        'assets/images/hotelcasablanca-aguaslindoia-sp/11.jpg'
                    ]
                }, {
                    key: 'pousadaflorescampo-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Pousada Flores do Campo',
                    type: 'guesthouse',
                    Icon: Nature,
                    description: 'attractionPousadaFloresCampoAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/pousadaflorescampo-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6382.628382438472!2d-46.59755249599831!3d-22.46312108582015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c91180b1b425cb%3A0x7da01876001f0048!2sPousada%20Flores%20do%20Campo%20-%20Deluxe%20Double%20Room!5e0!3m2!1spt-BR!2sbr!4v1770154486069!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/1.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/2.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/3.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/4.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/5.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/6.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/7.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/8.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/9.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/10.jpg',
                        'assets/images/pousadaflorescampo-aguaslindoia-sp/11.jpg'
                    ]
                }, {
                    key: 'pousadarecantocascata-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Pousada Recanto da Cascata',
                    type: 'guesthouse',
                    Icon: Nature,
                    description: 'attractionPousadaRecantoCascataAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/pousadarecantocascata-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3687.1583605918104!2d-46.624458424876785!3d-22.460682579571554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c91116328b665b%3A0xab1b7fbf9ad9db57!2sPousada%20Recanto%20da%20Cascata!5e0!3m2!1spt-BR!2sbr!4v1770154825671!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/1.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/2.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/3.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/4.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/5.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/6.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/7.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/8.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/9.jpg',
                        'assets/images/pousadarecantocascata-aguaslindoia-sp/10.jpg'
                    ]
                }, {
                    key: 'hotelsaoluiz-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hotel São Luiz',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotelSaoLuizAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/hotelsaoluiz-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14734.43688043837!2d-46.52555508241304!3d-22.593714467908903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c911acb8c7504d%3A0x6106b327a38d4702!2sHotel%20S%C3%A3o%20Luiz!5e0!3m2!1spt-BR!2sbr!4v1770155043148!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/1.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/2.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/3.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/4.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/5.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/6.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/7.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/8.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/9.jpg',
                        'assets/images/hotelsaoluiz-aguaslindoia-sp/10.jpg'
                    ]
                }, {
                    key: 'voaplazzahotel-aguaslindoia-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'VOA Plazza Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionVoaPlazzaHotelAguasLindoiaSpDescription',
                    wallpaper: 'assets/images/voaplazzahotel-aguaslindoia-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.7827998464722!2d-46.634547424876374!3d-22.474794979561437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c9105346229f45%3A0xa209967a8af40d4f!2sVOA%20Plazza%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1770155212366!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/voaplazzahotel-aguaslindoia-sp/1.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/2.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/3.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/4.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/5.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/6.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/7.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/8.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/9.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/10.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/11.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/12.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/13.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/14.jpg',
                        'assets/images/voaplazzahotel-aguaslindoia-sp/15.jpg'
                    ]
                }
            ],
            parks: [],
            gallery: [
                'assets/images/aguaslindoia-sp/1.jpg',
                'assets/images/aguaslindoia-sp/2.jpg',
                'assets/images/aguaslindoia-sp/3.jpg',
                'assets/images/aguaslindoia-sp/4.jpg',
                'assets/images/aguaslindoia-sp/5.jpg',
                'assets/images/aguaslindoia-sp/6.jpg',
                'assets/images/aguaslindoia-sp/7.jpg',
                'assets/images/aguaslindoia-sp/8.jpg',
                'assets/images/aguaslindoia-sp/9.jpg',
                'assets/images/aguaslindoia-sp/10.jpg',
                'assets/images/aguaslindoia-sp/11.jpg',
                'assets/images/aguaslindoia-sp/12.jpg',
                'assets/images/aguaslindoia-sp/13.jpg',
                'assets/images/aguaslindoia-sp/14.jpg'
            ]
        }, {
            key: 'aguassaopedro-sp',
            city: 'Águas de São Pedro',
            state: 'São Paulo',
            description: 'destinationAguasSaoPedroSpDescription',
            wallpaper: 'assets/images/aguassaopedro-sp/wallpaper.jpg',
            hotels: [
                {
                    key: 'saopedrothermasresort-aguassaopedro-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'São Pedro Thermas Resort',
                    type: 'resort',
                    Icon: BeachAccess,
                    description: 'attractionSaoPedroThermasResortAguasSaoPedroSpDescription',
                    wallpaper: 'assets/images/saopedrothermasresort-aguassaopedro-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.330640643176!2d-47.86077842011652!3d-22.641457726437213!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c7b10cb97a7d11%3A0x78211c595d8a07ac!2sS%C3%A3o%20Pedro%20Thermas%20Resort!5e0!3m2!1spt-BR!2sbr!4v1770149438880!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/1.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/2.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/3.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/4.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/5.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/6.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/7.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/8.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/9.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/10.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/11.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/12.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/13.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/14.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/15.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/16.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/17.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/18.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/19.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/20.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/21.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/22.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/23.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/24.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/25.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/26.jpg',
                        'assets/images/saopedrothermasresort-aguassaopedro-sp/27.jpg'
                    ]
                }, {
                    key: 'lsvillashotelspa-aguassaopedro-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'LS Villas Hotel & Spa',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionLsVillasHotelSpaAguasSaoPedroSpDescription',
                    wallpaper: 'assets/images/lsvillashotelspa-aguassaopedro-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.5019130636692!2d-47.87937122487248!3d-22.597725079473836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c7b10c821faf19%3A0x3b370b37669c4138!2sLS%20Villas%20Hotel%20%26%20SPA%20em%20%C3%81guas%20de%20S%C3%A3o%20Pedro!5e0!3m2!1spt-BR!2sbr!4v1770149928302!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/1.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/2.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/3.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/4.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/5.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/6.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/7.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/8.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/9.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/10.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/11.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/12.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/13.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/14.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/15.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/16.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/17.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/18.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/19.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/20.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/21.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/22.jpg',
                        'assets/images/lsvillashotelspa-aguassaopedro-sp/23.jpg'
                    ]
                }
            ],
            parks: [
                {
                    key: 'thermassaopedro-aguassaopedro-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Thermas de São Pedro',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionThermasSaoPedroAguasSaoPedroSpDescription',
                    wallpaper: 'assets/images/thermassaopedro-aguassaopedro-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourEveryDaysExceptWednesday',
                            value: '9h30 {at} 17h'
                        }, {
                            label: 'openingHourWeekendAndHolidays',
                            value: '9h30 {at} 17h30'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.3045017722106!2d-47.8583119248712!3d-22.642432779442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c7a5e217f21e9d%3A0xa96812d56d0e6921!2sThermas%20de%20S%C3%A3o%20Pedro!5e0!3m2!1spt-BR!2sbr!4v1770148761078!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/thermassaopedro-aguassaopedro-sp/1.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/2.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/3.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/4.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/5.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/6.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/7.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/8.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/9.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/10.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/11.jpg',
                        'assets/images/thermassaopedro-aguassaopedro-sp/12.jpg'
                    ]
                }
            ],
            gallery: [
                'assets/images/aguassaopedro-sp/1.jpg',
                'assets/images/aguassaopedro-sp/2.jpg',
                'assets/images/aguassaopedro-sp/3.jpg',
                'assets/images/aguassaopedro-sp/4.jpg',
                'assets/images/aguassaopedro-sp/5.jpg',
                'assets/images/aguassaopedro-sp/6.jpg',
                'assets/images/aguassaopedro-sp/7.jpg',
                'assets/images/aguassaopedro-sp/8.jpg',
                'assets/images/aguassaopedro-sp/9.jpg',
                'assets/images/aguassaopedro-sp/10.jpg',
                'assets/images/aguassaopedro-sp/11.jpg'
            ]
        }, {
            key: 'andradina-sp',
            city: 'Andradina',
            state: 'São Paulo',
            description: 'destinationAndradinaSpDescription',
            wallpaper: 'assets/images/andradina-sp/wallpaper.jpg',
            hotels: [
                {
                    key: 'wakandahotel-andradina-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Wakanda Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionWakandaHotelAndradinaSpDescription',
                    wallpaper: 'assets/images/wakandahotel-andradina-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3727.650940986933!2d-51.370560524923285!3d-20.886115080727723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9490b5bb7212535b%3A0xf251d3ca3116260f!2sWakanda%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1770151674377!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/wakandahotel-andradina-sp/1.jpg',
                        'assets/images/wakandahotel-andradina-sp/2.jpg',
                        'assets/images/wakandahotel-andradina-sp/3.jpg',
                        'assets/images/wakandahotel-andradina-sp/4.jpg',
                        'assets/images/wakandahotel-andradina-sp/5.jpg',
                        'assets/images/wakandahotel-andradina-sp/6.jpg',
                        'assets/images/wakandahotel-andradina-sp/7.jpg',
                        'assets/images/wakandahotel-andradina-sp/8.jpg',
                        'assets/images/wakandahotel-andradina-sp/9.jpg',
                        'assets/images/wakandahotel-andradina-sp/10.jpg',
                        'assets/images/wakandahotel-andradina-sp/11.jpg',
                        'assets/images/wakandahotel-andradina-sp/12.jpg',
                        'assets/images/wakandahotel-andradina-sp/13.jpg',
                        'assets/images/wakandahotel-andradina-sp/14.jpg',
                        'assets/images/wakandahotel-andradina-sp/15.jpg'
                    ]
                }, {
                    key: 'hoteloesteplaza-andradina-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hotel Oeste Plaza',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotelOestePlazaAndradinaSpDescription',
                    wallpaper: 'assets/images/hoteloesteplaza-andradina-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3727.717462743425!2d-51.37292822492332!3d-20.883435380729807!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9490b56772b1abe7%3A0xbbdd8bdde9fbddf7!2sHotel%20Oeste%20Plaza!5e0!3m2!1spt-BR!2sbr!4v1770151944923!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hoteloesteplaza-andradina-sp/1.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/2.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/3.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/4.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/5.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/6.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/7.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/8.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/9.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/10.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/11.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/12.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/13.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/14.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/15.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/16.jpg',
                        'assets/images/hoteloesteplaza-andradina-sp/17.jpg'
                    ]
                }
            ],
            parks: [
                {
                    key: 'thermasacqualinda-andradina-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Thermas Acqualinda',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionThermasAcqualindaAndradinaSpDescription',
                    wallpaper: 'assets/images/thermasacqualinda-andradina-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourSundayToSunday',
                            value: '10h {at} 17h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3727.4780262251365!2d-51.35275032492296!3d-20.893079080722487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9490cb5ef85659a5%3A0x8f1879418dd3316f!2sThermas%20Acqualinda!5e0!3m2!1spt-BR!2sbr!4v1770151255590!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/thermasacqualinda-andradina-sp/1.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/2.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/3.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/4.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/5.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/6.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/7.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/8.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/9.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/10.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/11.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/12.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/13.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/14.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/15.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/16.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/17.jpg',
                        'assets/images/thermasacqualinda-andradina-sp/18.jpg'
                    ]
                }
            ],
            gallery: [
                'assets/images/andradina-sp/1.jpg',
                'assets/images/andradina-sp/2.jpg',
                'assets/images/andradina-sp/3.jpg',
                'assets/images/andradina-sp/4.jpg',
                'assets/images/andradina-sp/5.jpg',
                'assets/images/andradina-sp/6.jpg',
                'assets/images/andradina-sp/7.jpg',
                'assets/images/andradina-sp/8.jpg',
                'assets/images/andradina-sp/9.jpg',
                'assets/images/andradina-sp/10.jpg'
            ]
        }, {
            key: 'barretos-sp',
            city: 'Barretos',
            state: 'São Paulo',
            description: 'destinationBarretosSpDescription',
            wallpaper: 'assets/images/barretos-sp/wallpaper.jpg',
            hotels: [
                {
                    key: 'barretoscountryresort-barretos-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Barretos Country Resort',
                    type: 'resort',
                    Icon: BeachAccess,
                    description: 'attractionBarretosCountryResortBarretosSpDescription',
                    wallpaper: 'assets/images/barretoscountryresort-barretos-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7470.909105481123!2d-48.58862840842186!3d-20.569486623869306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bb856c1f107571%3A0x55800daffc17e834!2sBarretos%20Country%20Park%20%26%20Resort!5e0!3m2!1spt-BR!2sbr!4v1770207875271!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/barretoscountryresort-barretos-sp/1.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/2.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/3.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/4.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/5.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/6.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/7.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/8.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/9.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/10.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/11.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/12.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/13.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/14.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/15.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/16.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/17.jpg',
                        'assets/images/barretoscountryresort-barretos-sp/18.jpg',
                    ]
                }, {
                    key: 'hoteldaninn-barretos-sp',
                    requestQuoteVariant: 'reservation',
                    name: 'Hotel Dan Inn Barretos',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotelDanInnBarretosSpDescription',
                    wallpaper: 'assets/images/hoteldaninn-barretos-sp/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3735.7227947403912!2d-48.57169712053076!3d-20.558519931922856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bb8530f5dcdc3b%3A0x9d2cc3d79dd37f25!2sHotel%20Dan%20Inn%20Barretos!5e0!3m2!1spt-BR!2sbr!4v1770208299799!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hoteldaninn-barretos-sp/1.jpg',
                        'assets/images/hoteldaninn-barretos-sp/2.jpg',
                        'assets/images/hoteldaninn-barretos-sp/3.jpg',
                        'assets/images/hoteldaninn-barretos-sp/4.jpg',
                        'assets/images/hoteldaninn-barretos-sp/5.jpg',
                        'assets/images/hoteldaninn-barretos-sp/6.jpg',
                        'assets/images/hoteldaninn-barretos-sp/7.jpg',
                        'assets/images/hoteldaninn-barretos-sp/8.jpg',
                        'assets/images/hoteldaninn-barretos-sp/9.jpg',
                        'assets/images/hoteldaninn-barretos-sp/10.jpg',
                        'assets/images/hoteldaninn-barretos-sp/11.jpg',
                        'assets/images/hoteldaninn-barretos-sp/12.jpg',
                        'assets/images/hoteldaninn-barretos-sp/13.jpg',
                        'assets/images/hoteldaninn-barretos-sp/14.jpg',
                        'assets/images/hoteldaninn-barretos-sp/15.jpg',
                        'assets/images/hoteldaninn-barretos-sp/16.jpg',
                    ]
                }
            ],
            parks: [
                {
                    key: 'barretoscountrypark-barretos-sp',
                    requestQuoteVariant: 'tickets',
                    name: 'Barretos Country Park',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionBarretosCountryParkBarretosSpDescription',
                    wallpaper: 'assets/images/barretoscountrypark-barretos-sp/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourEveryDays',
                            value: '10h {at} 17h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7470.909105481123!2d-48.58862840842186!3d-20.569486623869306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bb856c1f107571%3A0x55800daffc17e834!2sBarretos%20Country%20Park%20%26%20Resort!5e0!3m2!1spt-BR!2sbr!4v1770207875271!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/barretoscountrypark-barretos-sp/1.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/2.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/3.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/4.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/5.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/6.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/7.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/8.jpg',
                        'assets/images/barretoscountrypark-barretos-sp/9.jpg'
                    ]
                }
            ],
            gallery: [
                'assets/images/barretos-sp/1.jpg',
                'assets/images/barretos-sp/2.jpg',
                'assets/images/barretos-sp/3.jpg',
                'assets/images/barretos-sp/4.jpg',
                'assets/images/barretos-sp/5.jpg',
                'assets/images/barretos-sp/6.jpg',
                'assets/images/barretos-sp/7.jpg',
                'assets/images/barretos-sp/8.jpg',
                'assets/images/barretos-sp/9.jpg',
                'assets/images/barretos-sp/10.jpg',
                'assets/images/barretos-sp/11.jpg',
                'assets/images/barretos-sp/12.jpg',
                'assets/images/barretos-sp/13.jpg',
                'assets/images/barretos-sp/14.jpg',
                'assets/images/barretos-sp/15.jpg',
                'assets/images/barretos-sp/16.jpg',
                'assets/images/barretos-sp/17.jpg'
            ]
        }, {
            key: 'caldasnovas-go',
            city: 'Caldas Novas',
            state: 'Goiás',
            description: 'destinationCaldasNovasGoDescription',
            wallpaper: 'assets/images/caldasnovas-go/wallpaper.jpg',
            hotels: [
                {
                    key: 'boulevardsuitehotel-caldasnovas-go',
                    requestQuoteVariant: 'reservation',
                    name: 'Boulevard Suíte Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionBoulevardSuiteHotelCaldasNovasGoDescription',
                    wallpaper: 'assets/images/boulevardsuitehotel-caldasnovas-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.1351656894612!2d-48.63253502500625!3d-17.73826928320995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a736a594c6e80b%3A0xd77337b6e17ff95a!2sBoulevard%20Su%C3%ADte%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1770143665218!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/boulevardsuitehotel-caldasnovas-go/1.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/2.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/3.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/4.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/5.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/6.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/7.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/8.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/9.jpg',
                        'assets/images/boulevardsuitehotel-caldasnovas-go/10.jpg'
                    ]
                }, {
                    key: 'rivieraparkhotel-caldasnovas-go',
                    requestQuoteVariant: 'reservation',
                    name: 'Riviera Park Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionRivieraParkHotelCaldasNovasGoDescription',
                    wallpaper: 'assets/images/rivieraparkhotel-caldasnovas-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.1076275391683!2d-48.63592412103027!3d-17.739567239914262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a736afaf0fa053%3A0x477a628957bc71ec!2sRiviera%20Park%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1770143950420!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/rivieraparkhotel-caldasnovas-go/1.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/2.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/3.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/4.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/5.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/6.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/7.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/8.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/9.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/10.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/11.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/12.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/13.jpg',
                        'assets/images/rivieraparkhotel-caldasnovas-go/14.jpg',
                    ]
                }, {
                    key: 'marinaflatnautica-caldasnovas-go',
                    requestQuoteVariant: 'reservation',
                    name: 'Marina Flat & Náutica',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionMarinaFlatNauticaCaldasNovasGoDescription',
                    wallpaper: 'assets/images/marinaflatnautica-caldasnovas-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.3581285123373!2d-48.571741425005435!3d-17.77485818317988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a73064baf4cf33%3A0x56680f268c6bcaa8!2sMarina%20Flat%20%26%20N%C3%A1utica!5e0!3m2!1spt-BR!2sbr!4v1770144277399!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/marinaflatnautica-caldasnovas-go/1.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/2.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/3.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/4.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/5.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/6.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/7.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/8.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/9.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/10.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/11.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/12.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/13.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/14.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/15.jpg',
                        'assets/images/marinaflatnautica-caldasnovas-go/16.jpg',
                    ]
                }
            ],
            parks: [
                {
                    key: 'hotpark-caldasnovas-go',
                    requestQuoteVariant: 'tickets',
                    name: 'Hot Park',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionHotParkCaldasNovasGoDescription',
                    wallpaper: 'assets/images/hotpark-caldasnovas-go/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourFridayToWednesday',
                            value: '9h30 {at} 17h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15197.6461439298!2d-48.76158549939776!3d-17.772345680908945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a0cb7a3013d229%3A0xc858d6672f3a1746!2sHot%20Park!5e0!3m2!1spt-BR!2sbr!4v1770143328389!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotpark-caldasnovas-go/1.jpg',
                        'assets/images/hotpark-caldasnovas-go/2.jpg',
                        'assets/images/hotpark-caldasnovas-go/3.jpg',
                        'assets/images/hotpark-caldasnovas-go/4.jpg',
                        'assets/images/hotpark-caldasnovas-go/5.jpg',
                        'assets/images/hotpark-caldasnovas-go/6.jpg',
                        'assets/images/hotpark-caldasnovas-go/7.jpg',
                        'assets/images/hotpark-caldasnovas-go/8.jpg',
                        'assets/images/hotpark-caldasnovas-go/9.jpg',
                        'assets/images/hotpark-caldasnovas-go/10.jpg',
                        'assets/images/hotpark-caldasnovas-go/11.jpg',
                        'assets/images/hotpark-caldasnovas-go/12.jpg',
                        'assets/images/hotpark-caldasnovas-go/13.jpg',
                        'assets/images/hotpark-caldasnovas-go/14.jpg'
                    ]
                }
            ],
            gallery: [
                'assets/images/caldasnovas-go/1.jpg',
                'assets/images/caldasnovas-go/2.jpg',
                'assets/images/caldasnovas-go/3.jpg',
                'assets/images/caldasnovas-go/4.jpg',
                'assets/images/caldasnovas-go/5.jpg',
                'assets/images/caldasnovas-go/6.jpg',
                'assets/images/caldasnovas-go/7.jpg',
                'assets/images/caldasnovas-go/8.jpg',
                'assets/images/caldasnovas-go/9.jpg',
                'assets/images/caldasnovas-go/10.jpg',
                'assets/images/caldasnovas-go/11.jpg',
                'assets/images/caldasnovas-go/12.jpg',
                'assets/images/caldasnovas-go/13.jpg',
                'assets/images/caldasnovas-go/14.jpg',
                'assets/images/caldasnovas-go/15.jpg'
            ]
        }, {
            key: 'rioquente-go',
            city: 'Rio Quente',
            state: 'Goiás',
            description: 'destinationRioQuenteGoDescription',
            wallpaper: 'assets/images/rioquente-go/wallpaper.jpg',
            hotels: [
                {
                    key: 'serramadrehotel-rioquente-go',
                    requestQuoteVariant: 'reservation',
                    name: 'Serra Madre Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionSerraMadreHotelRioQuenteGoDescription',
                    wallpaper: 'assets/images/serramadrehotel-rioquente-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.3995074133927!2d-48.758004425005424!3d-17.772911583181468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a0cb7969eb4c83%3A0x987f67a912784ca5!2sSerra%20Madre%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1770145527522!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/serramadrehotel-rioquente-go/1.jpg',
                        'assets/images/serramadrehotel-rioquente-go/2.jpg',
                        'assets/images/serramadrehotel-rioquente-go/3.jpg',
                        'assets/images/serramadrehotel-rioquente-go/4.jpg',
                        'assets/images/serramadrehotel-rioquente-go/5.jpg',
                        'assets/images/serramadrehotel-rioquente-go/6.jpg',
                        'assets/images/serramadrehotel-rioquente-go/7.jpg',
                        'assets/images/serramadrehotel-rioquente-go/8.jpg',
                        'assets/images/serramadrehotel-rioquente-go/9.jpg',
                        'assets/images/serramadrehotel-rioquente-go/10.jpg',
                        'assets/images/serramadrehotel-rioquente-go/11.jpg',
                        'assets/images/serramadrehotel-rioquente-go/12.jpg'
                    ]
                }, {
                    key: 'giardinohotel-rioquente-go',
                    requestQuoteVariant: 'reservation',
                    name: 'Giardino Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionGiardinoHotelRioQuenteGoDescription',
                    wallpaper: 'assets/images/giardinohotel-rioquente-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.490907650076!2d-48.75868602500554!3d-17.768611083184968!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a0cb776f160b6b%3A0x905171c026820ad3!2sRio%20Quente%20Resorts%20-%20Hotel%20Giardino!5e0!3m2!1spt-BR!2sbr!4v1770145934892!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/giardinohotel-rioquente-go/1.jpg',
                        'assets/images/giardinohotel-rioquente-go/2.jpg',
                        'assets/images/giardinohotel-rioquente-go/3.jpg',
                        'assets/images/giardinohotel-rioquente-go/4.jpg',
                        'assets/images/giardinohotel-rioquente-go/5.jpg',
                        'assets/images/giardinohotel-rioquente-go/6.jpg',
                        'assets/images/giardinohotel-rioquente-go/7.jpg',
                        'assets/images/giardinohotel-rioquente-go/8.jpg',
                        'assets/images/giardinohotel-rioquente-go/9.jpg',
                        'assets/images/giardinohotel-rioquente-go/10.jpg',
                        'assets/images/giardinohotel-rioquente-go/11.jpg',
                        'assets/images/giardinohotel-rioquente-go/12.jpg',
                        'assets/images/giardinohotel-rioquente-go/13.jpg',
                        'assets/images/giardinohotel-rioquente-go/14.jpg',
                        'assets/images/giardinohotel-rioquente-go/15.jpg'
                    ]
                }, {
                    key: 'hotelluupi-rioquente-go',
                    requestQuoteVariant: 'reservation',
                    name: 'Hotel Luupi',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionHotelLuupiRioQuenteGoDescription',
                    wallpaper: 'assets/images/hotelluupi-rioquente-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.470493492887!2d-48.759640325005535!3d-17.769571683184264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a0cb7842f629bf%3A0xc5afed9dfec256c4!2sRio%20Quente%20Resorts%20-%20Hotel%20Luupi!5e0!3m2!1spt-BR!2sbr!4v1770146223996!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotelluupi-rioquente-go/1.jpg',
                        'assets/images/hotelluupi-rioquente-go/2.jpg',
                        'assets/images/hotelluupi-rioquente-go/3.jpg',
                        'assets/images/hotelluupi-rioquente-go/4.jpg',
                        'assets/images/hotelluupi-rioquente-go/5.jpg',
                        'assets/images/hotelluupi-rioquente-go/6.jpg',
                        'assets/images/hotelluupi-rioquente-go/7.jpg',
                        'assets/images/hotelluupi-rioquente-go/8.jpg',
                        'assets/images/hotelluupi-rioquente-go/9.jpg',
                        'assets/images/hotelluupi-rioquente-go/10.jpg',
                        'assets/images/hotelluupi-rioquente-go/11.jpg'
                    ]
                }, {
                    key: 'imghotel-rioquente-go',
                    requestQuoteVariant: 'reservation',
                    name: 'IMG Hotel',
                    type: 'hotel',
                    Icon: KingBed,
                    description: 'attractionImgHotelRioQuenteGoDescription',
                    wallpaper: 'assets/images/imghotel-rioquente-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.4041454202325!2d-48.759317825005496!3d-17.77269338318173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a0cb782305ad9b%3A0xf7ea86d0cf375b33!2sIMG%20Hotel%20Rio%20Quente!5e0!3m2!1spt-BR!2sbr!4v1770146459663!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/imghotel-rioquente-go/1.jpg',
                        'assets/images/imghotel-rioquente-go/2.jpg',
                        'assets/images/imghotel-rioquente-go/3.jpg',
                        'assets/images/imghotel-rioquente-go/4.jpg',
                        'assets/images/imghotel-rioquente-go/5.jpg',
                        'assets/images/imghotel-rioquente-go/6.jpg',
                        'assets/images/imghotel-rioquente-go/7.jpg',
                        'assets/images/imghotel-rioquente-go/8.jpg',
                        'assets/images/imghotel-rioquente-go/9.jpg',
                        'assets/images/imghotel-rioquente-go/10.jpg',
                        'assets/images/imghotel-rioquente-go/11.jpg',
                        'assets/images/imghotel-rioquente-go/12.jpg'
                    ]
                }
            ],
            parks: [
                {
                    key: 'hotpark-rioquente-go',
                    requestQuoteVariant: 'tickets',
                    name: 'Hot Park',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionHotParkRioQuenteGoDescription',
                    wallpaper: 'assets/images/hotpark-rioquente-go/wallpaper.jpg',
                    openingHours: [
                        {
                            label: 'openingHourFridayToWednesday',
                            value: '9h30 {at} 17h'
                        }
                    ],
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15197.6461439298!2d-48.76158549939776!3d-17.772345680908945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a0cb7a3013d229%3A0xc858d6672f3a1746!2sHot%20Park!5e0!3m2!1spt-BR!2sbr!4v1770143328389!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/hotpark-rioquente-go/1.jpg',
                        'assets/images/hotpark-rioquente-go/2.jpg',
                        'assets/images/hotpark-rioquente-go/3.jpg',
                        'assets/images/hotpark-rioquente-go/4.jpg',
                        'assets/images/hotpark-rioquente-go/5.jpg',
                        'assets/images/hotpark-rioquente-go/6.jpg',
                        'assets/images/hotpark-rioquente-go/7.jpg',
                        'assets/images/hotpark-rioquente-go/8.jpg',
                        'assets/images/hotpark-rioquente-go/9.jpg',
                        'assets/images/hotpark-rioquente-go/10.jpg',
                        'assets/images/hotpark-rioquente-go/11.jpg',
                        'assets/images/hotpark-rioquente-go/12.jpg',
                        'assets/images/hotpark-rioquente-go/13.jpg',
                        'assets/images/hotpark-rioquente-go/14.jpg'
                    ]
                }, {
                    key: 'parquefontes-rioquente-go',
                    requestQuoteVariant: 'tickets',
                    name: 'Parque das Fontes',
                    type: 'waterPark',
                    Icon: PoolOutlined,
                    description: 'attractionParqueFontesRioQuenteGoDescription',
                    wallpaper: 'assets/images/parquefontes-rioquente-go/wallpaper.jpg',
                    googleMaps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.362320594886!2d-48.750723925005445!3d-17.774660983180137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a0cb6320794cdd%3A0xb4ac072d1e56d8a7!2sParque%20das%20Fontes%20-%20Rio%20Quente%20Resorts!5e0!3m2!1spt-BR!2sbr!4v1770145225380!5m2!1spt-BR!2sbr',
                    gallery: [
                        'assets/images/parquefontes-rioquente-go/1.jpg',
                        'assets/images/parquefontes-rioquente-go/2.jpg',
                        'assets/images/parquefontes-rioquente-go/3.jpg',
                        'assets/images/parquefontes-rioquente-go/4.jpg',
                        'assets/images/parquefontes-rioquente-go/5.jpg',
                        'assets/images/parquefontes-rioquente-go/6.jpg',
                        'assets/images/parquefontes-rioquente-go/7.jpg'
                    ]
                }
            ],
            gallery: [
                'assets/images/rioquente-go/1.jpg',
                'assets/images/rioquente-go/2.jpg',
                'assets/images/rioquente-go/3.jpg',
                'assets/images/rioquente-go/4.jpg',
                'assets/images/rioquente-go/5.jpg',
                'assets/images/rioquente-go/6.jpg',
                'assets/images/rioquente-go/7.jpg',
                'assets/images/rioquente-go/8.jpg',
                'assets/images/rioquente-go/9.jpg',
                'assets/images/rioquente-go/10.jpg'
            ]
        }
    ]
}


const systemNameFormatted = DefaultConstants.websiteName.toLowerCase().replace(/ /g, '').toLowerCase();
const StorageConstants = {
    languageStorageName: `${systemNameFormatted}_currentlanguage`,
    authTokenStorageName: `${systemNameFormatted}_authtoken`
}


const KeyConstants = {
    privateKey: 'jz4ii5k7e7ujmstz'
}


export {
    StorageConstants,
    KeyConstants,
    WebsiteConstants
}

export default DefaultConstants;

